<template>
    <div class="form-group">
        <label :for="getId" class="label">
            {{ label }}
            {{ required ? '*' : '' }}
        </label>

        <select 
            @input="handleInput"
            :value="innerValue"
            :name="name"
            :required="required"
            :disabled="disabled"
            :id="getId"
            :placeholder="placeholder"
            class="form-select form-control"
            v-bind:class="{ 'is-invalid': error }"
        >
            <option v-if="!loading" :disabled="disableEmptyOption" :selected="!innerValue"></option>
            <option 
                v-for="(option, index) in generateOptions"
                :key="`${getId}-${index}`"
                :value="option"
                :selected="innerValue === option"
            >
                {{ option }}
            </option>
        </select>

        <small
            v-if="helperText"
            class="form-text"
            v-bind:class="{ 'invalid-feedback': error, 'text-muted': !error }"
        >
            {{ helperText }}
        </small>
    </div>
</template>

<script>

export default {
    props: {
        id: {
            type: String,
            required: false,
        },
        label: {
            type: String,
            required: false,
        },
        value: {
            required: true,
        },
        name: {
            type: String,
            required: false,
        },
        error: {
            type: Boolean,
            required: false,
            default: false
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
        helperText: {
            type: String,
            required: false,
            default: null
        },
        placeholder: {
            type: String,
            required: false,
        },
        required: {
            type: Boolean,
            required: false,
            default: false
        },
        options: {
            type: Array,
            required: true,
        },
        getOptionLabel: {
            type: Function,
            required: false,
            default: (option) => {
                if (option) {
                    return typeof option === 'object' ? option.label : String(option)
                } 
                return null
            }
        },
        disableEmptyOption: {
            type: Boolean,
            required: false,
            default: true
        },
        loading: {
            type: Boolean,
            required: false,
            default: false
        },
        loadingText: {
            type: String,
            required: false,
            default: 'Carregando opções'
        },
    },
    data(){
        return {
            content: this.value,
            randomId: null,
        };
    },
    computed: {
        getId () {
            return this.id ? this.id : this.randomId
        },
        innerValue() {
            return this.value ? this.getOptionLabel(this.value) : null;
        },
        generateOptions() {
            if (this.loading) {
                return [this.loadingText]
            }

            return this.options.map((option) => this.getOptionLabel(option))
        }
    },
    methods: {
        handleInput (e) {
            let value = this.options.find((option) => this.getOptionLabel(option) === e.target.value)
            this.$emit('input', value)
            this.$emit('change', value)
        },
    },
    mounted() {
        this.randomId = Math.random().toString(36).substr(2, 9)
    }
}
</script>

<style scoped lang="scss">
.text-field {

}
</style>
